import { render, staticRenderFns } from "./manualSms.vue?vue&type=template&id=05375025&scoped=true&"
import script from "./manualSms.vue?vue&type=script&lang=js&"
export * from "./manualSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05375025",
  null
  
)

export default component.exports